/**
 * Permission and User Authentication Routines
 * @author Chelsea Fenton (Fresche Solutions)
 * @date May 2020
 */

import store from "@/store/store";

let authService = {
    isUserType(type){
        let userData = store.getters["User/getUserData"];
        return userData.userType == type;
    },
    userAuthResourcePriv(resource){
        let userData = store.getters["User/getUserData"];

        // checked for logged in user data's existence
        if (!userData || !userData.userAuthorities) {
            return false;
        }

        // get the permissions from the user data
        let permissions = userData.userAuthorities;

        if (typeof resource == 'object') {
            // return boolean for whether any resource from the array object is in the permissions array
            for (let i = 0; i < resource.length; i++) {
                if (permissions.includes(resource[i])) {
                    return true;
                }
            }

            return false;
        } else {
            // return boolean for whether the resource is in the permissions array
            return permissions.includes(resource);
        }
    },
    userAuthRoute(to) {
        if (to.meta.resource == undefined) {
            return true;
        }

        return authService.userAuthResourcePriv(to.meta.resource);
    },
    userAuthRouteName(routeName, router) {
        let findRoute;
        try {
            findRoute = router.resolve({
                name: routeName,
            });
        } catch (e) {
            // Vue Router 4 throws when the route name doesn't exist
            return false;
        }

        // route not found
        if (!findRoute || !findRoute.matched || !findRoute.matched.length) {
            return false;
        }

        return authService.userAuthRoute(findRoute);
    },
    userAuthChildRoutes(childRoutes, router) {
        let authorized = false;

        // check if any child routes are authorized
        childRoutes.forEach((route) => {
            let childAuth = authService.userAuthRouteName(route.routeName, router);

            if (childAuth) {
                authorized = true;
            }
        });

        return authorized;
    },
    requireAuth(to, from, next) {
        // if session not set properly - go to login
        if (!window.vm) {
            // save path for redirect after checking login
            window.sessionStorage.redirectTo = to.path;
            next("/pages/Login");
            return;
        }

        // check if user logged in
        let loggedIn = store.getters["User/getLoggedIn"];
        let loginDate = new Date(window.sessionStorage.loginDate).setHours(0, 0, 0, 0);
        let today = new Date().setHours(0, 0, 0, 0);

        if (loggedIn && today == loginDate) {
            if (authService.userAuthRoute(to)) {
                next();
            } else {
                next("/pages/NotAuth");
            }
        } else if (loggedIn && today != loginDate) {
            store.dispatch("User/logout");

            next("/pages/Login");
        } else {
            // if not logged in - go to login
            next("/pages/Login");
        }
    },
    hasAdminPermissions() {
        if (authService.userAuthResourcePriv('UserAdmin', 'list')) return true;
        if (authService.userAuthResourcePriv('RoleAdmin', 'list')) return true;
        return false;
    },
    isUserLoggedIn() {
        return store.getters["User/getLoggedIn"];
    },
};

export { authService };
